import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/docs/")({
	component: DocsIndexPage,
});

function DocsIndexPage() {
	const { t } = useTranslation("docs");
	return (
		<div className="max-w-2xl mx-auto">
			<h1 className="text-xl font-bold text-zinc-900 dark:text-zinc-100 mb-1">
				{t("title")}
			</h1>
			<p className="text-sm text-zinc-500 mb-8">{t("index_subtitle")}</p>

			<Section title={t("phase1_section")}>
				<Card
					href="/docs/phase1"
					title={t("phase1_overview")}
					desc={t("index_phase1_overview_desc")}
				/>
				<Card
					href="/docs/phase1/procurement"
					title={t("phase1_procurement")}
					desc={t("index_phase1_procurement_desc")}
				/>
				<Card
					href="/docs/phase1/sales"
					title={t("phase1_sales")}
					desc={t("index_phase1_sales_desc")}
				/>
				<Card
					href="/docs/phase1/admin"
					title={t("phase1_admin")}
					desc={t("index_phase1_admin_desc")}
				/>
			</Section>

			<Section title="Portal API">
				<Card
					href="/docs/portal/endpoints"
					title={t("endpoints")}
					desc="REST API для поиска продуктов, управления каталогами контрагентов, B2B-каталоги с индивидуальными ценами, схема данных и ключи API."
				/>
				<Card
					href="/docs/portal/widget"
					title={t("widget")}
					desc={t("index_portal_widget_desc")}
				/>
			</Section>

			<Section title={t("plugins_section")}>
				<Card
					href="/docs/plugins"
					title={t("overview")}
					desc={t("index_plugins_overview_desc")}
				/>
				<Card
					href="/docs/plugins/getting-started"
					title={t("getting_started")}
					desc={t("index_plugins_getting_started_desc")}
				/>
				<Card
					href="/docs/plugins/sdk-reference"
					title={t("sdk_reference")}
					desc={t("index_plugins_sdk_desc")}
				/>
				<Card
					href="/docs/plugins/capabilities"
					title={t("capabilities")}
					desc={t("index_plugins_capabilities_desc")}
				/>
				<Card
					href="/docs/plugins/publishing"
					title={t("publishing")}
					desc={t("index_plugins_publishing_desc")}
				/>
			</Section>
		</div>
	);
}

function Section({
	title,
	children,
}: { title: string; children: React.ReactNode }) {
	return (
		<div className="mb-8">
			<h2 className="text-xs font-semibold text-zinc-400 uppercase tracking-wider mb-3">
				{title}
			</h2>
			<div className="grid gap-2">{children}</div>
		</div>
	);
}

function Card({
	href,
	title,
	desc,
}: { href: string; title: string; desc: string }) {
	return (
		<Link
			to={href as "/docs/plugins"}
			className="group flex items-start gap-3 rounded-lg border border-zinc-200 dark:border-zinc-800 px-4 py-3 hover:border-zinc-300 dark:hover:border-zinc-700 hover:bg-zinc-50 dark:hover:bg-zinc-900/50 transition-colors"
		>
			<div className="min-w-0">
				<div className="text-sm font-medium text-zinc-900 dark:text-zinc-100 group-hover:text-primary transition-colors">
					{title}
				</div>
				<div className="text-[12px] text-zinc-500 mt-0.5 leading-relaxed">
					{desc}
				</div>
			</div>
		</Link>
	);
}
